import React from 'react'
import './index.scss'

class TopNav extends React.Component {

    

    render() {
        return (
            <nav className="top-nav">
                <ul>
                    <li><a href="#">About</a></li>
                    <li><a href="#">About</a></li>
                    <li><a href="#">About</a></li>
                    <li><a href="#">About</a></li>
                </ul>
            </nav>
        )
    }
}

export default TopNav



// WEBPACK FOOTER //
// ./src/components/TopNav/index.js